export type LoyaltyPointsBundleId =
  | 'BUNDLE_500'
  | 'BUNDLE_1100'
  | 'BUNDLE_2300'
  | 'BUNDLE_4500'
  | 'BUNDLE_9000';

export const LOYALTY_POINTS_HISTORY_SOURCES = {
  EARNED: 'EARNED',
  PURCHASED: 'PURCHASED',
  REDEEMED: 'REDEEMED',
  REFUNDED: 'REFUNDED',
  EXPIRED: 'EXPIRED'
} as const;

export type LoyaltyPointsHistorySource =
  (typeof LOYALTY_POINTS_HISTORY_SOURCES)[keyof typeof LOYALTY_POINTS_HISTORY_SOURCES];

export type LoyaltyPointsActivityCode =
  | 'COMMENT'
  | 'FAN_LOGIN'
  | 'COMMENT_FEED'
  | 'COMMENT_CHAT'
  | 'ENGAGE_CONTENT'
  | 'SUPPORT_CREATOR'
  | 'FAN_RECRUITMENT'
  | 'SHARE_CONTENT';

export interface LoyaltyPointsPackage {
  bundle_id: LoyaltyPointsBundleId;
  points: number;
  bonus: number;
  total_points: number;
  price: number;
  base_price: number;
  is_active: boolean;
  currency_code: string;
  currency_symbol: string;
  currency_name: string;
  exchange_rate_to_usd: number;
}

export interface LoyaltyPointsPackagesState {
  is_active: boolean;
  bundles: LoyaltyPointsPackage[];
}

export interface LoyaltyPointsPackagesResponse {
  status: boolean;
  statusCode: number;
  message: string;
  data: LoyaltyPointsPackagesState;
}

export interface LoyaltyPointsHistoryEntry {
  points: number;
  source: LoyaltyPointsHistorySource;
  created_at: number;
  activity_code?: LoyaltyPointsActivityCode;
  expires_at?: number;
  bundle_id?: LoyaltyPointsBundleId;
}

export interface LoyaltyPointsWalletState {
  earned_points_balance: number;
  purchased_points_balance: number;
  current_points_balance: number;
  points_history: LoyaltyPointsHistoryEntry[];
}

export interface LoyaltyPointsWalletResponse {
  status: boolean;
  statusCode: number;
  message: string;
  data: LoyaltyPointsWalletState;
}

export interface PurchasePointsPayload {
  bundle_id: LoyaltyPointsBundleId;
  creator_id: string;
}

export interface PurchasePointsResponse {
  status: boolean;
  statusCode: number;
  message: string;
  data: {
    order_sk: string;
  };
}

export interface LoyaltyPointsSummaryCard {
  label: string;
  infoMessage: string;
  value: number;
}

export interface LoyaltyPointsPaymentUser {
  gsi4pk: string;
  first_name: string;
  last_name: string;
  user_name?: string;
}

export interface LoyaltyPointsPaymentData {
  amount: number;
  localPrice: number;
  exchangeRateUSD: number;
  currency_symbol: string;
  orderSK: string;
  callType: string;
  plan_name: string;
  points: number;
  bundle_id: LoyaltyPointsBundleId;
  user: LoyaltyPointsPaymentUser;
}
